import React, { useState, useEffect, FC } from 'react';
import RealtimeListener, { PushkinConfiguration } from '../../utils/realtime/RealtimeListener';
import { useWorkExperience } from '../../hooks/useWorkExperience';
import { useIsSelfViewFreelancer } from '../../hooks/useIsSelfViewFreelancer';
import { AddWorkExperienceBlock } from './components/AddWorkExperienceBlock';
import WorkExperienceDrawer from './components/WorkExperienceDrawer';
import { WorkExperience } from './components/WorkExperienceComponent';

const pushkinClient = RealtimeListener;

interface WorkExperienceResolverProps {
    titleClassName?: string;
    pushkinConfiguration?: PushkinConfiguration;
}

export const WorkExperienceResolver: FC<WorkExperienceResolverProps> = ({ pushkinConfiguration, titleClassName }) => {
    const isSelfView = useIsSelfViewFreelancer();
    const { showWorkExperience, hasWorkExperience, isDrawerOpenByDefault } = useWorkExperience();
    const [isDrawerOpen, setIsDrawerOpen] = useState(isDrawerOpenByDefault);

    useEffect(() => {
        setIsDrawerOpen((isDrawerOpen) => isDrawerOpenByDefault || isDrawerOpen);
    }, [isDrawerOpenByDefault]);

    useEffect(() => {
        const channelName = pushkinConfiguration?.channels?.[0];

        const initClient = async () => {
            if (pushkinConfiguration) {
                await pushkinClient.init(pushkinConfiguration);
                if (channelName) {
                    await pushkinClient.subscribe(channelName, {});
                }
            }
        };

        initClient();
        return () => {
            if (channelName) {
                pushkinClient.unsubscribe(channelName);
            }
        };
    }, [pushkinConfiguration]);

    if (!showWorkExperience) {
        return null;
    }

    return (
        <>
            <WorkExperienceDrawer
                setIsDrawerOpen={setIsDrawerOpen}
                isDrawerOpen={isDrawerOpen}
                pushkinClient={pushkinClient}
            />
            {hasWorkExperience ? (
                <WorkExperience titleClassName={titleClassName} setIsDrawerOpen={setIsDrawerOpen} />
            ) : (
                isSelfView && <AddWorkExperienceBlock setIsDrawerOpen={setIsDrawerOpen} />
            )}
        </>
    );
};

export default WorkExperienceResolver;
